<template>
  <!-- 连接线 -->
  <div class="">
    <el-form label-width="2.4rem" >
      <el-form-item label="关系标注">
        <el-input v-model="edgeInfo.relationName" placeholder="请输入标记名称"></el-input>
      </el-form-item>
      <div v-if="checkTypeEnable">
        <el-form-item label="审批结果">
          <!-- 取值与后端 wf_flow_task.task_result 保持一致：100-通过，200-驳回 -->
          <el-select v-model="edgeInfo.checkType" >
            <el-option :value="0" label="未选择" />
            <el-option :value="100" label="通过" />
            <el-option :value="200" label="驳回"/>
          </el-select>
        </el-form-item>
      </div>
      <div v-if="multi">
        <el-form-item label="条件分支">
          <el-select v-model="edgeInfo.conditionType" clearable>
            <el-option :value="1" label="同时满足所有条件" />
            <el-option :value="2" label="只需满足条件之一"/>
            <el-option :value="3" label="不满足其它分支条件时"/>
          </el-select>
        </el-form-item>
      </div>
    </el-form>
    <div v-if="multi && (edgeInfo.conditionType === 1 || edgeInfo.conditionType === 2)">
      <h3>条件设置</h3>
      <!-- 有多个条件 -->
      <div v-for="(con, ridx) in edgeInfo.conditionList" :key="ridx">
        <!-- 如果这个条件是一个分组 -->
        <el-card v-if="con.itemType === 2"  class="condition-item">
          <div style="display: flex;justify-content: space-between;">
            <el-select v-model="con.conditionType"  style="width: 200px;margin-bottom: 10px">
              <el-option :value="1" label="同时满足所有条件" />
              <el-option :value="2" label="只需满足条件之一"/>
            </el-select>
            <yq-icon name="element-ui_close" class="delete-group" @click="removeCondition(2, [ridx])"/>
          </div>
          <div v-if="con.conditionList && con.conditionList.length > 0" v-for="(field, i) in con.conditionList" :key="i">

            <node-check-condition :field-condition="field" :index="[ridx, i]" :level="3" :flow-forms="currentAbleCondition" @remove="removeCondition" @change="changeCondition"/>
          </div>
          <el-button  type="primary" @click="con.conditionList.push({itemType: 1})">
            <yq-icon name="element-ui_plus"/>
          </el-button>
        </el-card>
        <!-- 是分组条件 -->
        <div v-else class="condition-item">
          <div>
            <node-check-condition :field-condition="con" :index="[ridx]" :level="2" :flow-forms="currentAbleCondition" @remove="removeCondition" @change="changeCondition"/>
          </div>
        </div>
      </div>
      <div>
        <table-button @click="rootAddCondition(1)"><yq-icon name="element-ui_plus"/>添加条件</table-button>
        <table-button @click="rootAddCondition(2)"><yq-icon name="element-ui_plus"/>添加分组</table-button>
      </div>
    </div>
  </div>
</template>

<script>
import NodeCheckCondition from "./NodeCheckCondition.vue";
import customerComponentCheck from "./CustomerComponentCheck";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqIcon from "@/components/YqIcon.vue";
export default {
  props: {
    relationData: {default: () => {}}, // 连接线数据
    parentNode: {default: () => {}}, // 上级的节点
    multi: {default: false}, // 是否是多条件，只有多条件，即一个节点，连接多个下级节点时，才能设置条件分支
    columnList: {default: () => []}, // 哪些字段可用
  },
  watch: {
    relationData: {
      handler() {
        this.init();
      }
    },
    columnList: {
      handler() {
        this.columnListInit();
      }
    },
  },
  name: "",
  components: {
    YqIcon,
    TableButton,
    NodeCheckCondition
  },
  data() {
    return {
      edgeInfo: {
        relationName: "",
        conditionList: [],
      },
      // 当前节点的可选择的审批条件
      currentAbleCondition: [],
      checkTypeEnable: false, // 是否是审批关联，当上一个节点是审批节点时，是审批关联，仅能设置审批通过或拒绝
    };
  },
  created() {
    this.columnListInit();
    this.init();
  },
  methods: {
    /**
     * 整理可用的条件字段。
     * formLabel 用于界面展示（可读的业务名，如「请假天数」），
     * fieldName 仅用于表达式求值（物理列名，如 days）——两者不能混用，
     * 配置人员看到 days 根本不知道是什么意思。
     */
    columnListInit() {
      let arr = [];
      for (let i = 0; i < this.columnList.length; i++) {
        const field = this.columnList[i];
        // 业务节点(900)不是可比较字段，不参与条件判断
        if (field.fieldType === 900) {
          continue;
        }
        arr.push({
          id: field.id,
          formLabel: field.fieldLabel,
          fieldName: field.fieldName,
          formType: field.fieldType,
          // 数据字典类型要靠它去拉对应字典的选项列表，其余类型用不到
          fieldCode: field.fieldCode,
          formOptions: field.options
        });
      }
      this.currentAbleCondition = arr;
    },
    init() {
      this.checkTypeEnable = this.parentNode.nodeType === 'approve';
      let edgeInfo = {...this.relationData.data};
      if (!edgeInfo.conditionType) {
        edgeInfo.conditionType = "";
      }
      if (!edgeInfo.conditionList) {
        edgeInfo.conditionList = [];
      }
      this.edgeInfo = edgeInfo;
    },
    // 移除某个查询条件
    removeCondition(level, idx) {
      if (level === 2) {
        this.edgeInfo.conditionList = this.edgeInfo.conditionList.remove(idx[0]);
      } else if (level === 3) {
        this.edgeInfo.conditionList[idx[0]].conditionList = this.edgeInfo.conditionList[idx[0]].conditionList.remove(idx[1]);
      }
      this.$forceUpdate();
    },
    // 变更某个条件
    changeCondition(level, idx, data) {
      if (level === 2) {
        this.edgeInfo.conditionList[idx[0]] = data;
      } else if (level === 3){
        this.edgeInfo.conditionList[idx[0]].conditionList[idx[1]]= data;
      }
      this.$forceUpdate();
    },
    /**
     * 在根节点下添加条件项或条件分组。
     * itemType 只标记这一项是「条件」还是「分组」，与字段类型(fieldType)无关——
     * 两者曾经同名，容易混淆，这里显式区分。
     */
    rootAddCondition(itemType) {
      this.edgeInfo.conditionList.push({itemType: itemType, conditionList: []});
    },
    // 返回数据，并进行验证
    getData() {
      // 多条件
      if (this.multi) {
        let info = {
          ...this.relationData,
          ...this.edgeInfo
        }
        // 每一个条件，必须设置条件
        let edgeInfo = {
          ...info,
          properties: {
            ...info
          }
        }
        let message = customerComponentCheck.relationValid(edgeInfo, null, true);
        if (edgeInfo.properties.invalid && message) {
          // 无效关联数据
          this.$message.error(message);
          throw new Error(message);
        }
        return edgeInfo;

      } else {
        return this.edgeInfo;
      }
    },
  }
};
</script>

<style lang="scss" scoped>

</style>